"use client";
import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
import { FreeMode, Thumbs, Navigation } from "swiper/modules";
import "swiper/css/navigation";
import Fav from "@/public/icon/fav.svg";
import New from "@/public/icon/new.svg";
import Award from "@/public/icon/award.svg";
import Stock from "@/public/icon/stock.svg";
import Product from "@/public/images/product.jpg";
import Image from "next/image";
import Fb from "@/public/icon/fb.svg";
import X from "@/public/icon/tw.svg";
import Tg from "@/public/icon/tg.svg";
import Copy from "@/public/icon/copy.svg";
import Wp from "@/public/icon/whatsappred.svg";
import Link from "next/link";
import QuantitySelector from "@/components/Quantity/Quantity";
import Cart from "@/public/icon/cart.svg";
import Rating from "@/public/icon/rating.svg";
import Share from "../Share/Share";
import { useCheckout } from "@/hooks/useCheckout";
import { useWishlist } from "@/hooks/useWishlist";
import { useSession } from "@/hooks/useSession";
import baseQueries from "@/libs/provideBaseQueriesOnFilterUrl";

/**
 * 2026-10-13 — şəkil variantını ölçüyə görə seç.
 * Media 3 ölçüdə saxlanılır: thumbnail 300px, slider 400px, main 1201px.
 * Əvvəl hər yerdə `thumbnail` işlədilirdi: 300px-lik şəkil 828px-ə dartılır,
 * məhsulun əsas şəkli isə 400px `slider`-dən 1920px-ə — ona görə bulanıq çıxırdı.
 */
const pickImage = (img, prefer = "main") => {
  if (!img) return null;
  const order =
    prefer === "slider"
      ? [img.slider, img.main, img.thumbnail]
      : [img.main, img.slider, img.thumbnail];
  const found = order.find(Boolean);
  if (found) return found;
  return img.filepath && img.filename
    ? `${img.filepath}${img.filename}`
    : null;
};

const ProductSlide = ({
  // item,
  // volumes,
  // sticker,
  // out_of_stock,
  data,
  // title,
  t,
}) => {
  const { session } = useSession();
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const { addToCart } = useCheckout();
  const [selectedVolumeId, setSelectedVolumeId] = useState(null);
  const [count, setCount] = useState(1);
  useEffect(() => {
    if (data?.volumes?.length > 0) {
      setSelectedVolumeId(data.volumes[0].id);
    }
  }, [data.volumes]);

  const handleAddToCart = () => {
    addToCart({
      product_id: data.id,
      volume_id: selectedVolumeId,
      count: count,
      succesMessage: t["success.message"],
      errorMessage: t["error.title"],
    });
  };
  const [currentUrl, setCurrentUrl] = useState("");

  useEffect(() => {
    if (typeof window !== "undefined") {
      setCurrentUrl(window.location.href);
    }
  }, []);

  const messageText =
    data.out_of_stock === 0
      ? `Salam, bu ətiri sifariş vermək istəyirəm: ${currentUrl}`
      : `Salam, bu ətir yenidən stokda olduqda mənə məlumat verə bilərsinizmi? Zəhmət olmasa, ${currentUrl}`;
  const message = encodeURIComponent(messageText);
  const whatsappLink = `https://wa.me/994508205555?text=${message}`;

  const { isWished, addToWishlist } = useWishlist();
  const wished = isWished(data.id);
  const [isWishedActive, setIsWishedActive] = useState(wished);

  useEffect(() => {
    setIsWishedActive(wished);
  }, [wished]);
  const toggleWishlist = () => {
    addToWishlist(data.id);
    setIsWishedActive(!isWishedActive);
  };
  return (
    <div className="row">
      
      <div className="xl-5 lg-5 md-5 sm-12">
        <div className="productDetailLeft">
          {session && (
            <div
              className={`favButton ${isWishedActive ? "active" : ""}`}
              onClick={toggleWishlist}
            >
              <Fav />
            </div>
          )}
          <div className="badges">
            {data?.sticker?.id === 4 ? (
              <div className="sale badge">
                <Award />
                {data.sticker.title}
              </div>
            ) : null}
            {data?.sticker?.id === 1 ? (
              <div className="new badge">
                <New />
                {data.sticker.title}
              </div>
            ) : null}
            {data?.out_of_stock === 1 ? (
              <div className="stock badge">
                <Stock />
                {t["forms.out_of_stock"]}
              </div>
            ) : null}
          </div>
          <Swiper
            spaceBetween={10}
            thumbs={{ swiper: thumbsSwiper }}
            modules={[FreeMode, Thumbs]}
            className="mySwiper2"
          >
            <SwiperSlide>
              <div className="img">
                <Image
                  src={pickImage(data?.title_image, "main") || Product}
                  alt="product"
                  width={800}
                  height={800}
                  quality={90}
                  sizes="(max-width: 767px) 92vw, 36vw"
                />
              </div>
            </SwiperSlide>
            {data.volumes?.length > 1
              ? data.volumes.map((item) => (
                  <SwiperSlide key={item.id}>
                    <div className="img">
                      <Image
                        src={
                          pickImage(item.title_image, "main") ||
                          pickImage(data?.title_image, "main") ||
                          Product
                        }
                        alt="product"
                        width={800}
                        height={800}
                        quality={90}
                        sizes="(max-width: 767px) 92vw, 36vw"
                      />
                    </div>
                  </SwiperSlide>
                ))
              : data.volumes?.length === 1 ? (
              <SwiperSlide>
                <div className="img">
                  <Image
                    src={
                      pickImage(data.volumes[0].title_image, "main") ||
                      pickImage(data?.title_image, "main") ||
                      Product
                    }
                    alt="single"
                    width={800}
                    height={800}
                    quality={90}
                    sizes="(max-width: 767px) 92vw, 36vw"
                  />
                </div>
              </SwiperSlide>
            ) : null}
          </Swiper>
        </div>
      </div>
      <div className="xl-7 lg-7 md-7 sm-12">
        <div className="row">
          <div className="xl-6 lg-6 md-6 sm-12">
            <div className="productDetailTop">
              <div className="productDetailVolume">
                <span>{t["site_content.select_perfume_volume"]}:</span>
                <Swiper
                  onSwiper={setThumbsSwiper}
                  spaceBetween={10}
                  slidesPerView={5}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[FreeMode, Thumbs]}
                  className="mySwiper"
                  direction="vertical"
                >
                  <SwiperSlide></SwiperSlide>

                  {data.volumes?.length > 1
                    ? data?.volumes?.map((item) => (
                        <SwiperSlide key={item.id}>
                          <div className="volumeCard">
                            <input
                              type="radio"
                              name="volume"
                              onChange={() => setSelectedVolumeId(item.id)}
                              checked={selectedVolumeId === item.id}
                            />
                            <div className="volumeCardInner">
                              <div className="img">
                                <Image
                                  src={
                                    pickImage(item.title_image, "slider") ||
                                    pickImage(data?.title_image, "slider") ||
                                    Product
                                  }
                                  alt="product"
                                  width={400}
                                  height={400}
                                />
                              </div>
                              <div className="volumeDetail">
                                <span>{item.volume}</span>
                                {item.sale_price == 0 ||
                                item.sale_price == null ? (
                                  <div className="price">{item.price} ₼</div>
                                ) : (
                                  <>
                                    {item.price != item.sale_price ? (
                                      <div className="price">
                                        {item.sale_price} ₼
                                      </div>
                                    ) : (
                                      <div className="price">
                                        {item.price} ₼
                                      </div>
                                    )}
                                    {item.price != item.sale_price ? (
                                      <div className="discount">
                                        {item.price} ₼
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    : data.volumes?.length === 1
                    ? data?.volumes?.map((item) => (
                        <SwiperSlide key={item.id}>
                          <div className="volumeCard">
                            <input
                              type="radio"
                              name="volume"
                              onChange={() => setSelectedVolumeId(item.id)}
                              checked={selectedVolumeId === item.id}
                            />
                            <div className="volumeCardInner">
                              <div className="img">
                                <Image
                                  src={
                                    pickImage(item.title_image, "slider") ||
                                    pickImage(data?.title_image, "slider") ||
                                    Product
                                  }
                                  alt="product"
                                  width={200}
                                  height={200}
                                />
                              </div>
                              <div className="volumeDetail">
                                <span>{item.volume}</span>
                                {item.sale_price == 0 ||
                                item.sale_price == null ? (
                                  item.price
                                ) : (
                                  <>
                                    {item.price != item.sale_price ? (
                                      <div className="price">
                                        {item.sale_price} ₼
                                      </div>
                                    ) : (
                                      <div className="price">
                                        {item.price} ₼
                                      </div>
                                    )}
                                    {item.price != item.sale_price ? (
                                      <div className="discount">
                                        {item.price} ₼
                                      </div>
                                    ) : null}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    : null}
                </Swiper>

                <div className="volumeCardBottom">
                  <QuantitySelector count={count} onChange={setCount} />
                  {data?.out_of_stock === 1 ? (
                    <button
                      type="button"
                      className="blackButton outofStockButton"
                    >
                      {t["forms.out_of_stock"]}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="blackButton"
                      onClick={handleAddToCart}
                    >
                      <Cart />
                      {t["buttons.add_to_basket"]}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="xl-6 lg-6 md-6 sm-12">
            <div className="productTopRightParent">
              {/* todo */}
              <div className="productDetailRight">
                <h3>{data?.brand?.title}</h3>

                {data?.rating === 0 ? null : (
                  <div className="rating">
                    <Rating />({data?.rating} )
                  </div>
                )}
                {data?.date > 0 && (
                  <p>
                    {t["forms.date"]}:<span>{data?.date}</span>
                  </p>
                )}
                {data?.brand > 0 && (
                  <p>
                    {t["table.header.brand"]}:
                    <Link
                      href={`/products?brand=${
                        data?.brand?.path
                      }&${baseQueries.toString()}`}
                    >
                      {data?.brand?.title}
                    </Link>
                  </p>
                )}
                {data?.gender && (
                  <p>
                    {t["forms.gender"]}
                    <Link
                      href={`/products?genders=${
                        data?.gender_alias
                      }&${baseQueries.toString()}`}
                    >
                      {data?.gender}
                    </Link>
                  </p>
                )}
                {data?.author && (
                  <p>
                    {t["title.parfumer"]}:
                    <Link
                      href={`/products?authors=${
                        data?.author?.alias
                      }&${baseQueries.toString()}`}
                    >
                      {data?.author?.full_name}
                    </Link>
                  </p>
                )}
                {data?.groups && (
                  <p>
                    {t["forms.groups"]}:
                    <span>
                      {data?.groups?.map((group) => (
                        <Link
                          href={`/products?groups=${
                            group.alias
                          }&${baseQueries.toString()}`}
                          key={group.id}
                        >
                          {group.title}
                        </Link>
                      ))}
                    </span>
                  </p>
                )}
                {data?.season && (
                  <p>
                    {t["forms.season"]}:<span>{data?.season}</span>
                  </p>
                )}
                {data?.part_of_day && (
                  <p>
                    {t["title.perfume_time"]}:<span>{data?.part_of_day}</span>
                  </p>
                )}
              </div>
              <div className="productDetailShare">
                <div className="shareButtons">
                  <Link
                    href={whatsappLink}
                    className="whatsappShare"
                    target="_blank"
                  >
                    <Wp />
                    <span>{t["titli.order_with_one_click"]}</span>
                  </Link>
                  <Share t={t} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSlide;
